"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGameLibraryTemplate = void 0;
exports.defaultGameLibraryTemplate = {
    gameId: '',
    gameName: '',
    gameLibraryId: '',
    templateTitle: '',
    templateDescriptionText: '',
    templateImage: 'https://prod-cdn.flarie.com/asset/template-library/template_library.png',
    isEnableCase: false,
    caseLink: '',
    caseText: '',
    caseLogo: '',
    isActive: false,
};
